<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'group'}">
              <a>ゲートグループ一覧 </a>
            </router-link>
            <li class="active">新規ゲートグループ登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>新規ゲートグループ登録</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-success" v-if="message_success">
            {{ message_success }}
          </div>
          <div class="alert alert-danger" v-if="message_error">
            {{ message_error }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <div class="col-md-offset-2 col-md-10"><span id="name_error" class="error_m"></span></div>
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ゲートグループ名 <font class="input-required">※必須</font></label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" placeholder="ゲートグループ名" v-model="groupInfor.name" @blur="validateBeforeSubmit">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ステータス</label>
                <div class="col-sm-1">
                  <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="groupInfor.isValid">
                  <span class="lbl"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-10">
                  <router-link :to="{ name: 'group'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="addGroup" >
                    保存
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      groupInfor: {
        name: '',
        isValid: true
      },
      flagU: false,
      flag: false,
      message_success: '',
      message_error: '',
      loading: false,
      isEnabledSave: false // IF true: Enabled button 保存, false: disabled button 保存
    }
  },
  created () {
  },
  methods: {
    validateBeforeSubmit () {
      this.flag = true
      if (this.groupInfor.name === null || this.groupInfor.name === '') {
        $('#name_error').html('ゲートグループ名は必須です。')
        $('#name').addClass('error')
        this.flagU = false
      } else {
        $('#name_error').html('')
        $('#name').removeClass('error')
        this.flagU = true
      }
      if (this.groupInfor.name !== null && this.groupInfor.name !== '') {
        if (this.groupInfor.name.length > 64) {
          $('#name_error').html('ゲートグループ名は64文字以内で入力してください。')
          $('#name').addClass('error')
          this.flag = false
        } else {
          $('#name_error').html('')
          $('#name').removeClass('error')
          this.flag = true
        }
      }
      this.isEnabledSave = false
      if (this.flag && this.flagU) {
        this.isEnabledSave = true
      }
    },
    reset () {
      this.groupInfor.name = ''
      this.groupInfor.isValid = true
    },
    addGroup () {
      this.validateBeforeSubmit()
      if (this.flag && this.flagU) {
        this.loading = true
        var groupInfor = {
          name: this.groupInfor.name,
          isValid: this.groupInfor.isValid
        }
        console.log(groupInfor)
        this.$http.post(Config.GROUPS_LIST_API, JSON.stringify(groupInfor))
          .then(response => {
            if (response.body.message === 'Success') {
              this.loading = false
              this.reset()
              this.message_success = Config.ADD_GROUP_API_SUCCESS
              this.message_error = ''
            } else {
              this.loading = false
              this.message_error = Config.ADD_API_ERROR
              this.message_success = ''
            }
          })
          .catch((error) => {
            this.message_success = ''
            if (error.body) {
              this.loading = false
              switch (error.status) {
                case 401:
                  if (error.body.message === 'The incoming token has expired') {
                    this.message_error = ''
                  } else {
                    this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                  }
                  break
                case 400:
                  this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                  break
                case 403:
                  this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                  break
                case 409:
                  this.message_error = '入力されたゲートグループ名は既に使用されています。他のゲートグループ名を入力してください。'
                  break
                case 500:
                  this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                  break
                case 503:
                  this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                  break
                default:
                  this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                  break
              }
            } else {
              this.loading = false
              this.message_error = Config.SERVER_CONNECT_ERROR
            }
          })
      }
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
  .field{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    background: #ABBAC3;
  }
</style>



// WEBPACK FOOTER //
// src/views/group/GroupAdd.vue